import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-experiences',
  templateUrl: './experiences.component.html',
  styleUrls: ['./experiences.component.css']
})
export class ExperiencesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.GetWhatsappNos();
  }

  WhatsappList:any[]=[];
  GetWhatsappNos()
  {
    let nos =  (<HTMLInputElement>document.getElementById("hdnWhatsapp")).value;
    this.WhatsappList = nos.split(",");
  }

}
